/*
 * @Date: 2023-03-08 14:57:33
 * @LastEditors: 雷安刚 15108293674@163.com
 * @Author: 雷安刚 15108293674@163.com
 * @LastEditTime: 2023-11-09 16:17:41
 * @FilePath: \front_admin\src\router\modules\autoClassify\index.js
 * @Description: 注释描述
 */
//自动分类
let autoClassify = () => import('@/components/agentAccount/autoClassify/index')

//销项分类
let outPutClassify = () => import('@/components/agentAccount/autoClassify/outPutClassify/outPutClassify')
//进项分类
let incomeClassify = () => import('@/components/agentAccount/autoClassify/incomeClassify/incomeClassify')
//进销项标记(总览)
let markClassAll = () => import('@/components/agentAccount/autoClassify/markClassAll/markClassAll')
//A组分类标记
let markClassA = () => import('@/components/agentAccount/autoClassify/outPutClassify/markClassA')
//B组分类标记
let markClassB = () => import('@/components/agentAccount/autoClassify/incomeClassify/markClassB')
//B组分类标记
let logClassify = () => import('@/components/agentAccount/autoClassify/logClassify')

export default [
  {
    path: '/markClassAll',
    component: markClassAll,
    name: 'markClassAll',
    meta: {
      text: '进销项标记(总览)',
    },
  },
  {
    path: '/logClassify',
    component: logClassify,
    name: 'logClassify',
    meta: {
      text: '标记日志',
    },
  },
  {
    path: '/autoClassify',
    component: autoClassify,
    children: [{
        path: '/outPutClassify',
        component: outPutClassify,
        name: 'outPutClassify',
        meta: {
          text: '销项分类',
        },
      },
      {
        path: '/incomeClassify',
        component: incomeClassify,
        name: 'incomeClassify',
        meta: {
          text: '进项分类',
        },
      },
      {
        path: '/markClassA',
        component: markClassA,
        name: 'markClassA',
        meta: {
          text: 'A组分类标记',
        },
      },
      {
        path: '/markClassB',
        component: markClassB,
        name: 'markClassB',
        meta: {
          text: 'B组分类标记',
        },
      }
    ]
  }
]
